import { UserCurrency } from 'models/currency.interface';

export const sortByTotalAmount = (array: UserCurrency[]) => array.sort((a, b) => (
  b?.totalAmount - a?.totalAmount
));
